module.exports = __webpack_public_path__ + "img/picture_viptk02.f6ab917e.png";